import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/mapa',
    pathMatch: 'full',
  },
  {
    path: 'mapa',
    loadComponent: () => import('./pages/map/map.page').then((m) => m.MapPage),
    children: [
      {
        path: 'enclaves',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./components/map/map-enclave/map-enclave').then((m) => m.MapEnclave),
          },
          {
            path: ':slug',
            loadComponent: () =>
              import('./components/map/map-enclave/map-enclave-single/map-enclave-single').then(
                (m) => m.MapEnclaveSingle,
              ),
          },
        ],
      },
      {
        path: 'rutas',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./components/map/map-route/map-route').then((m) => m.MapRoute),
          },
          {
            path: ':slug',
            loadComponent: () =>
              import('./components/map/map-route/map-route-single/map-route-single').then(
                (m) => m.MapRouteSingle,
              ),
          },
        ],
      },
      {
        path: '**',
        redirectTo: 'enclaves',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'enclaves',
    children: [
      {
        path: ':slug',
        loadComponent: () => import('./pages/enclave/enclave.page').then((m) => m.EnclavePage),
      },
    ],
  },
  {
    path: 'rutas',
    children: [
      {
        path: ':slug',
        loadComponent: () => import('./pages/route/route.page').then((m) => m.RoutePage),
      },
    ],
  },
  {
    path: 'politica-de-privacidad',
    loadComponent: () =>
      import('./pages/legal/pages/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
  },
  {
    path: 'politica-de-cookies',
    loadComponent: () =>
      import('./pages/legal/pages/cookie-policy/cookie-policy').then((m) => m.CookiePolicy),
  },
];
